<template>
  <div>
    <div class="row mb-4">
      <div class="col-12 subtitle">
        Cada estudiante usará un computador o tablet individualmente
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button class="button secondary" @click="showModal.Work1To1 = true">
          Crear Trabajo 1 a 1
        </button>
        <button class="button primary mx-3">Historial</button>
      </div>
    </div>

    <div class="row">
      <Work1To1Modal
        v-if="showModal.Work1To1"
        @close="showModal.Work1To1 = false"
      />
    </div>
  </div>
</template>

<script>
import Work1To1Modal from "@/components/workSession/Work1To1Modal";

export default {
  name: "work1To1",
  components: {
    Work1To1Modal,
  },
  data() {
    return {
      showModal: {
        Work1To1: false,
      },
    };
  },
};
</script>
